import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { normalizer, smootherPause } from "./smoother";

gsap.registerPlugin(ScrollTrigger);

export const navToggle = () => {
    const navbar = document.querySelector('.navbar');
    const body = document.querySelector('body');
    const navBtn = navbar.querySelector('.navbar__burger');
    if( body.classList.contains('navbar__offcanvas--action') ){
        body.classList.add('overflow-hidden');
    }
    else{
        body.classList.remove('overflow-hidden');
    }
    navBtn.addEventListener('click', () => {
        body.classList.toggle('navbar__offcanvas--active');
        body.classList.contains('navbar__offcanvas--active') ? normalizer(false) : normalizer(true);
        if (document.querySelector('.theme-main').getAttribute('data-barba-namespace') == 'index') {
            body.classList.contains('navbar__offcanvas--active') ? gsap.set('.navbar__logo', {autoAlpha: 1, pointerEvents: 'auto'}) : gsap.set('.navbar__logo', {autoAlpha: 0}) ;
        }
    })
}
